const puzzle = {
  id: "b3jJlrAjob4z64dyYRsB",
  name: "A Chunk of Evil",
  rebuses: [
    {
      id: "8a0328a8-163c-411e-ae44-e46b25ab1eb6",
      clues: [
        {
          id: "0cdcabe3-7b-f348ba9df827",
          clueValues: [
            {
              id: "4a85fc08-08cb-4177-aa83-c8e6d1738fed",
              value: "EdgarCryptogram",
              type: "customComponent",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "F M L = T H E",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "815dbdb7-01a5-446a-b599-574d83926169",
            value: "Edgar Allan Poe",
          },
        ],
        solvedText: "Edgar Allan Poe",
      },
    },
    {
      id: "40a930d3-1ebd-4325-9511-7a32e3b25687",
      clues: [
        {
          id: "7b94ef87-3d9d-4108-ad53-2c83a78f96be",
          clueValues: [
            {
              id: "a48c9602-6b3a-4578-a5f9-efce05d780fd",
              value: "1U37PuUF.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText:
            "Find the name of a famous bell inside of this tower in London.",
          subtext: "Uncle",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "11111-3d9d-4108-ad53-2c83a78f96be",
          clueValues: [
            {
              id: "a48c9652-6b3a-4578-a5f9-efce05d780fd",
              value: "nm2IEqWB.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "Name of the 5th month.",
          subtext: "Aunt",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "4d84dbcb-c000-4d50-87bb-b8272bd8e81e",
            value: "Spiderman",
          },
          {
            id: "45454cb-c000-4d50-87bb-b8272bd8e81e",
            value: "Peter Parker",
          },
          {
            id: "2866b4da-b22b-4d76-8455-40f9c5265976",
            value: "Spider-Man",
          },
        ],
        solvedText: "Spider-Man",
      },
    },
    {
      id: "8c5ca215-88cb-49ca-a3c4-22b2ebd69ca4",
      clues: [
        {
          id: "ce9ede0b-63e9-4edb-90b2-c070afa4ea3b",
          clueValues: [
            {
              id: "d94ef8a5-a323-4488-8883-b9d56c83fea6",
              value: "Benito Mussolini",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "He became a prime minister.",
          subtext: "",
          clueGroup: 1,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "18e42512-1f7a-47f6-9368-9c8ae5b01097",
          clueValues: [
            {
              id: "ee0b1834-00fa-464b-a766-4a77da86d6cc",
              value: "Mount Rushmore",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "It was finished.",
          subtext: "",
          clueGroup: 1,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "b2294bd7-6998-4508-b5aa-af94431389a0",
          clueValues: [
            {
              id: "4f4d35a7-3878-4a55-8b36-e93628240c09",
              value: "Harry Houdini",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "He died.",
          subtext: "",
          clueGroup: 1,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "be6be400-b6e0-45f3-9d49-d18e1ec50cc0",
          clueValues: [
            {
              id: "5f36fcc7-c948-4891-8687-bb5f331dbfb1",
              value: "q3kdOfGe.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText:
            "Find the date these three clues have in common and type in the name of the holiday.",
          subtext: "Holiday",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "2c33e381-77e5-4c19-8b90-de32361750e1",
            value: "Halloween",
          },
        ],
        solvedText: "Halloween",
      },
    },
    {
      id: "48f2f7e8-28b3-46d1-af31-c0c42390c6e7",
      clues: [
        {
          id: "eaec540d-d885-42ea-a644-78ce7183a24b",
          clueValues: [
            {
              id: "40b32b38-517a-44a6-9f85-df5647654574",
              value: "Edgar Allan Poe",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          subtext: "Story",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "68ce5adb-de8c-495a-821d-7dc830fb65f9",
          clueValues: [
            {
              id: "f642a96a-b6b1-4951-8c96-be4362d1539b",
              value: "Spider-Man",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          subtext: "Character",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "4eab4b7a-c318-4939-b856-864e7922c82f",
          clueValues: [
            {
              id: "3a662eae-c75b-43cf-8a04-621d20ca6f26",
              value: "Halloween",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          subtext: "Symbol",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "3f53da84-073b-4974-8340-eeb26496289a",
            value: "Black Cat",
          },
          {
            id: "4444444-073b-4974-8340-eeb26496289a",
            value: "The Black Cat",
          },
        ],
        solvedText: "Black Cat",
      },
    },
  ],
};

export default puzzle;
